export default "/public/dist/img/Logo-Gazzetta-Ufficiale.jpg";